export const colunas = [
  {
    title: 'Contato',
    dataIndex: 'ContatoNome',
    key: 'ContatoNome'
  },
  {
    title: 'CodigoABS',
    dataIndex: 'CodigoABS',
    key: 'CodigoABS'
  },
  {
    title: 'Cliente',
    dataIndex: 'ClienteNome',
    key: 'ClienteNome'
  },
  {
    title: 'Botijão',
    dataIndex: 'Botijao',
    key: 'Botijao'
  },
  {
    title: 'Quantidade',
    className: 'text-right',
    dataIndex: 'Quantidade',
    key: 'Quantidade'
  }
]